export const DELIVERY_LOCATIONS = [
    'Front door',
    'Back door',
    'Side porch',
    'Garage',
    'Reception',
    'Mailroom',
    'Other',
    'No Preference',
] as const;

export const DELIVERY_INSTRUCTIONS_RESERVED_TOKEN = '~|~';
export const DELIVERY_INSTRUCTIONS_SEPARATOR = ` ${DELIVERY_INSTRUCTIONS_RESERVED_TOKEN} `;
export const DELIVERY_INSTRUCTIONS_RESERVED_TOKEN_MESSAGE = 'The sequence "~|~" is restricted. Please remove it.';
export const DELIVERY_INSTRUCTIONS_MAX_ENTRY_CODE_LENGTH = 10;
export const DELIVERY_INSTRUCTIONS_MAX_NOTES_LENGTH = 200;
export const DELIVERY_INSTRUCTIONS_MAX_SERIALIZED_LENGTH = 250;
export const DELIVERY_INSTRUCTIONS_LABELS = {
    location: 'Location',
    code: 'Code',
    notes: 'Notes',
} as const;

export const INVALID_LOCATION_MESSAGE = 'Select a valid drop-off location.';
export const ENTRY_CODE_LENGTH_MESSAGE = 'Entry code must be 10 characters or fewer.';
export const NOTES_LENGTH_MESSAGE = 'Delivery notes must be 200 characters or fewer.';
export const UNSUPPORTED_CHARACTERS_MESSAGE = 'Emojis and special font characters aren’t supported.';
export const COMBINED_LENGTH_MESSAGE =
    'Shorten the entry code or delivery notes so the combined delivery instructions are 250 characters or fewer.';
export const INVALID_TYPE_MESSAGE = 'Enter a valid value.';
